import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";
import Button from "components/CustomButtons/Button";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import AntDDataGrid from "components/DataGrid/AntDDataGrid";
import styles from "../ReportStyles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { updateReportBody } from "../reportUtils";

const OfficesClassroomsLaboratories = ({ data, report, setReportBody }) => {
  const [valueContent, setValueContent] = useState(data.description ?? "");

  const handleChangeDescription = (content) => {
    setValueContent(content);
    updateReportBody(
      setReportBody,
      "CRITERION7_FACILITIES",
      "OfficesClassroomsLaboratories",
      "description",
      content
    );
  };

  return (
    <>
      <h3>FACILITIES: Offices, Classrooms and Laboratories</h3>

      <p className={styles.reportParagraphTitle}>
        The following is a summary of each of the program’s facilities in terms
        of their ability to support the attainment of the student outcomes and
        to provide an atmosphere conducive to learning:
      </p>
      <ul>
        <li>
          Offices (such as administrative, faculty, clerical, and teaching
          assistants) and any associated equipment that is typically available
          there.
        </li>
        <li>
          Classrooms and associated equipment that are typically available where
          the program courses are taught.
        </li>
        <li>
          Laboratory facilities including those containing computers and the
          associated tools and equipment that support instruction (hardware and
          software). Appendix C contains a listing of the major pieces of
          equipment used by the program in support of instruction.
        </li>
      </ul>

      <HTMLEditor
        valueContent={valueContent}
        setValueContent={handleChangeDescription}
      />

      <br />
      <p className={styles.reportParagraphTitle}>
        The following is the list of the offices, classrooms and laboratories
        facilities initially defined for the program's courses:
      </p>

      <ul>
        {data?.officesClassroomsLaboratoriesFacilities?.map(
          (facility, index) => (
            <li key={facility.id}>{facility.resources}</li>
          )
        )}
      </ul>
    </>
  );
};

export default OfficesClassroomsLaboratories;
